import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { LeagueRankWrapper } from '@seedlang/hoc';
import React from 'react';
import { depixify, pixify } from '@seedlang/utils';

const Wrapper = styled.div`
  width: ${props => props.width};
  text-align: center;
  position: relative;
  margin: ${props => props.margin || '0 10px 0 0'};
`;

const CircleIcon = styled.div`
  background: ${props => props.displayOverBadge ? `${props.background}cc` : props.background}; /* cc is hex for 0.8 opacity */
  width: ${props => props.width};
  height: ${props => props.width};
  border-radius: ${props => props.width};
  color: ${props => props.color};
  line-height: ${props => props.lineHeight};
  font-weight: bold;
  font-size: 12px;
  border: 2px solid ${props => props.borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;

@observer
class LeagueRank extends React.Component {

  static defaultProps = {
    width: '25px',
  };

  render() {
    return (
      <Wrapper
        width={this.props.width}
        margin={this.props.margin}
      >
        <CircleIcon
          width={this.props.width}
          lineHeight={pixify(depixify(this.props.width) - 4)}
          background={this.props.background}
          borderColor={this.props.borderColor}
          color={this.props.promotionStatus === 0 ? '#333' : '#FFF'}
          displayOverBadge={this.props.displayOverBadge}
        >
          {this.props.rank || this.props.children}
        </CircleIcon>
      </Wrapper >
    );
  }
}

export default LeagueRankWrapper(LeagueRank);
